import type { FontFamily } from 'packages/types/fonts';

export type LoadedFonts = {
    families: FontFamily[];
    /** When this response came back, which is what makes the list stale later. */
    loadedAt: number;
};

/**
 * `loaded` is what the last successful request returned. A new request and a failed request both
 * keep it, so the page shows the list it already had instead of blanking or dropping to an error.
 */
export type FontList =
    // Declared here as undefined so `loaded` can be read without narrowing the status first.
    | { status: 'not started'; loaded?: undefined }
    | { status: 'loading'; loaded?: LoadedFonts }
    | { status: 'error'; errors: unknown; loaded?: LoadedFonts }
    | { status: 'ready'; loaded: LoadedFonts };

export enum actionTypes {
    GET_FONT_FAMILIES_REQUEST = 'GET_FONT_FAMILIES_REQUEST',
    GET_FONT_FAMILIES_SUCCESS = 'GET_FONT_FAMILIES_SUCCESS',
    GET_FONT_FAMILIES_FAILURE = 'GET_FONT_FAMILIES_FAILURE',
}
